(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-the-look"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.meriphoraCompleteLookBlock) {
      return;
    }

    const blockSelector = '[data-complete-look-block]';

    const getCartSectionIds = () => {
      const sectionIds = new Set();

      document.querySelectorAll('cart-items-component').forEach((component) => {
        if (component instanceof HTMLElement && component.dataset.sectionId) {
          sectionIds.add(component.dataset.sectionId);
        }
      });

      return Array.from(sectionIds).join(',');
    };

    const setButtonText = (button, text) => {
      button.textContent = text;
    };

    const animateButton = (button) => {
      button.classList.remove('is-added');
      void button.offsetWidth;
      button.classList.add('is-added');
      window.setTimeout(() => button.classList.remove('is-added'), 900);
    };

    const formatMoney = (block, cents) => {
      const amount = Number(cents || 0);
      const shopify = window.Shopify;

      if (shopify && typeof shopify.formatMoney === 'function' && block.dataset.moneyFormat) {
        return shopify.formatMoney(amount, block.dataset.moneyFormat);
      }

      const locale = document.documentElement.lang || navigator.language || 'en';
      const currency = shopify?.currency?.active || 'CHF';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(amount / 100);
      } catch (error) {
        return (amount / 100).toFixed(2);
      }
    };

    const getVariants = (item) => {
      const script = item.querySelector('[data-complete-look-variants-json]');

      if (!(script instanceof HTMLScriptElement)) {
        return [];
      }

      try {
        return JSON.parse(script.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const getSelectedOptions = (item) => {
      return Array.from(item.querySelectorAll('[data-complete-look-option-group]')).map((group) => {
        const selectedButton = group.querySelector('[data-complete-look-option-button].is-selected');
        return selectedButton instanceof HTMLButtonElement ? selectedButton.dataset.optionValue || '' : '';
      });
    };

    const findVariantByOptions = (variants, selectedOptions) => {
      return variants.find((variant) => {
        if (!Array.isArray(variant.options)) {
          return false;
        }

        return selectedOptions.every((option, index) => variant.options[index] === option);
      });
    };

    const updateOptionAvailability = (item, variants, selectedOptions) => {
      item.querySelectorAll('[data-complete-look-option-group]').forEach((group, groupIndex) => {
        group.querySelectorAll('[data-complete-look-option-button]').forEach((button) => {
          if (!(button instanceof HTMLButtonElement)) {
            return;
          }

          const candidateOptions = [...selectedOptions];
          candidateOptions[groupIndex] = button.dataset.optionValue || '';
          const candidateVariant = findVariantByOptions(variants, candidateOptions);
          const isAvailable = Boolean(candidateVariant?.available);

          button.classList.toggle('is-unavailable', !isAvailable);
          button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        });
      });
    };

    const updateItemVariant = (item) => {
      const variants = getVariants(item);
      const selectedOptions = getSelectedOptions(item);
      const variant = findVariantByOptions(variants, selectedOptions);

      if (!variant) {
        updateOptionAvailability(item, variants, selectedOptions);
        return;
      }

      const input = item.querySelector('[data-complete-look-variant-input]');

      if (input instanceof HTMLInputElement) {
        input.value = String(variant.id);
        input.dataset.priceCents = String(variant.priceCents || 0);
      }

      const price = item.querySelector('[data-complete-look-price]');

      if (price && variant.price) {
        price.textContent = variant.price;
      }

      const productId = item.dataset.productId;
      const mediaItem = productId
        ? document.querySelector(`[data-complete-look-media-item="${productId}"]`)
        : null;
      const image = mediaItem?.querySelector('img');

      if (image instanceof HTMLImageElement && variant.image) {
        image.src = variant.image;
        image.removeAttribute('srcset');
      }

      item.classList.toggle('is-unavailable', !variant.available);

      const checkbox = item.querySelector('[data-complete-look-checkbox]');

      if (checkbox instanceof HTMLInputElement) {
        checkbox.disabled = !variant.available;

        if (!variant.available) {
          checkbox.checked = false;
        }
      }

      updateOptionAvailability(item, variants, selectedOptions);
    };

    const refreshAllItems = () => {
      document.querySelectorAll(blockSelector).forEach((block) => {
        if (!(block instanceof HTMLElement)) {
          return;
        }

        block.querySelectorAll('[data-complete-look-item]').forEach((item) => {
          if (item instanceof HTMLElement) {
            updateItemVariant(item);
          }
        });

        updateTotal(block);
      });
    };

    const collectItems = (block) => {
      const items = [];
      block.querySelectorAll('[data-complete-look-item]').forEach((item) => {
        const isCurrentItem = item.hasAttribute('data-complete-look-current-item');
        const checkbox = item.querySelector('[data-complete-look-checkbox]');

        if (!isCurrentItem) {
          if (!(checkbox instanceof HTMLInputElement) || !checkbox.checked || checkbox.disabled) {
            return;
          }
        }

        if (item.classList.contains('is-unavailable')) {
          return;
        }

        const input = item.querySelector('[data-complete-look-variant-input]');
        let variantId = '';
        let priceCents = 0;

        if (input instanceof HTMLInputElement) {
          variantId = input.value;
          priceCents = Number(input.dataset.priceCents || 0);
        }

        if (variantId) {
          items.push({ id: Number(variantId), quantity: 1, priceCents });
        }
      });

      return items;
    };

    const updateTotal = (block) => {
      const total = collectItems(block).reduce((sum, item) => sum + item.priceCents, 0);
      const totalPrice = block.querySelector('[data-complete-look-total-price]');

      if (totalPrice) {
        totalPrice.textContent = formatMoney(block, total);
      }
    };

    const handleSubmit = async (button) => {
      const block = button.closest(blockSelector);
      const message = block?.querySelector('[data-complete-look-message]');

      if (!(block instanceof HTMLElement)) {
        return;
      }

      const items = collectItems(block);

      if (!items.length) {
        if (message) {
          message.textContent = block.dataset.errorMessage || '';
        }

        return;
      }

      const defaultText = button.dataset.defaultText || button.textContent || '';
      const addedText = button.dataset.addedText || defaultText;
      const sections = getCartSectionIds();
      const payload = {
        items: items.map(({ id, quantity }) => ({ id, quantity })),
      };

      if (sections) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }

      button.disabled = true;

      try {
        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const addResponse = await response.json();

        if (!response.ok || addResponse.status) {
          throw new Error(addResponse.message || addResponse.description || block.dataset.errorMessage || '');
        }

        let cart = addResponse;

        try {
          const cartResponse = await fetch('/cart.js');
          cart = await cartResponse.json();
        } catch (error) {
          cart = addResponse;
        }

        block.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: block.dataset.blockId,
              data: {
                source: 'meriphora-complete-look',
                itemCount: items.reduce((sum, item) => sum + item.quantity, 0),
                sections: addResponse.sections || {},
              },
            },
          })
        );
        animateButton(button);

        if (message) {
          message.textContent = '';
        }

        setButtonText(button, addedText);
        window.setTimeout(() => setButtonText(button, defaultText), 1800);
      } catch (error) {
        if (message) {
          message.textContent = error.message || block.dataset.errorMessage || '';
        }
      } finally {
        button.disabled = false;
      }
    };

    document.addEventListener('click', (event) => {
      const optionButton = event.target.closest('[data-complete-look-option-button]');

      if (optionButton instanceof HTMLButtonElement) {
        const group = optionButton.closest('[data-complete-look-option-group]');
        const item = optionButton.closest('[data-complete-look-item]');

        if (!group || !(item instanceof HTMLElement) || optionButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        event.preventDefault();

        group.querySelectorAll('[data-complete-look-option-button]').forEach((button) => {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });

        optionButton.classList.add('is-selected');
        optionButton.setAttribute('aria-pressed', 'true');

        const selectedText = group.querySelector('[data-complete-look-option-selected]');

        if (selectedText) {
          selectedText.textContent = optionButton.dataset.optionValue || '';
        }

        updateItemVariant(item);
        const block = item.closest(blockSelector);

        if (block instanceof HTMLElement) {
          updateTotal(block);
        }
        return;
      }

      const button = event.target.closest('[data-complete-look-submit]');

      if (button instanceof HTMLButtonElement) {
        handleSubmit(button);
      }
    });

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-complete-look-checkbox]')) {
        return;
      }

      const block = event.target.closest(blockSelector);

      if (block instanceof HTMLElement) {
        updateTotal(block);
      }
    });

    document.addEventListener('shopify:section:load', refreshAllItems);
    window.addEventListener('load', refreshAllItems);

    window.meriphoraCompleteLookBlock = true;
    refreshAllItems();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["meriphora-page-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.meriphoraPageDrawerInitialized) {
      return;
    }

    window.meriphoraPageDrawerInitialized = true;

    const focusableSelector = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    const getRoot = (element) => element.closest('[data-meriphora-page-drawer]');

    const getRootByDrawerId = (drawerId) => {
      return Array.from(document.querySelectorAll('[data-meriphora-page-drawer]')).find((root) => {
        return root.dataset.meriphoraDrawerId === drawerId;
      });
    };

    const getOverlay = (root) => {
      const drawerId = root.dataset.meriphoraDrawerId;
      return Array.from(document.querySelectorAll('[data-meriphora-drawer-overlay]')).find((overlay) => {
        return overlay.dataset.meriphoraDrawerId === drawerId;
      });
    };

    const getRootFromOverlayChild = (element) => {
      const overlay = element.closest('[data-meriphora-drawer-overlay]');
      if (!overlay) {
        return null;
      }

      return getRootByDrawerId(overlay.dataset.meriphoraDrawerId);
    };

    const applyProductFitSummary = (root, overlay) => {
      const productFitSummary = root.dataset.meriphoraProductFitSummary;

      if (!productFitSummary) {
        return;
      }

      overlay.querySelectorAll('[data-product-fit-summary]').forEach((target) => {
        target.textContent = productFitSummary;
      });
    };

    const syncGuideVisibility = (guide) => {
      const activeCountry = guide.dataset.activeCountry || 'de';
      const activeUnit = guide.dataset.activeUnit || 'cm';

      guide.querySelectorAll('[data-unit-visible], [data-country-visible]').forEach((item) => {
        const itemCountry = item.dataset.countryVisible;
        const itemUnit = item.dataset.unitVisible;
        const countryMismatch = itemCountry && itemCountry !== activeCountry;
        const unitMismatch = itemUnit && itemUnit !== activeUnit;

        item.hidden = Boolean(countryMismatch || unitMismatch);
      });

      guide.querySelectorAll('[data-size-guide-unit-toggle]').forEach((button) => {
        button.setAttribute('aria-pressed', activeUnit === 'in' ? 'true' : 'false');
      });
    };

    const syncDrawerThemeVariables = (root, overlay) => {
      const rootStyles = window.getComputedStyle(root);
      [
        '--color-background',
        '--color-foreground',
        '--color-foreground-rgb',
        '--color-background-rgb',
        '--meriphora-page-drawer-width',
        '--meriphora-page-drawer-overlay-opacity',
        '--meriphora-page-drawer-content-padding',
      ].forEach((name) => {
        const value = rootStyles.getPropertyValue(name);
        if (value) {
          overlay.style.setProperty(name, value);
        }
      });
    };

    const openDrawer = (root) => {
      const overlay = getOverlay(root);
      const trigger = root.querySelector('[data-meriphora-drawer-trigger]');

      if (!overlay || !trigger) {
        return;
      }

      if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }

      const closeButton = overlay.querySelector('[data-meriphora-drawer-close]');

      applyProductFitSummary(root, overlay);
      overlay.querySelectorAll('[data-meriphora-size-guide]').forEach(syncGuideVisibility);
      syncDrawerThemeVariables(root, overlay);
      overlay.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('meriphora-page-drawer-lock');

      requestAnimationFrame(() => {
        root.classList.add('is-open');
        overlay.classList.add('is-open');
        if (closeButton) {
          closeButton.focus({ preventScroll: true });
        }
      });
    };

    const closeDrawer = (root) => {
      const overlay = getOverlay(root);
      const trigger = root.querySelector('[data-meriphora-drawer-trigger]');

      if (!overlay || overlay.hidden) {
        return;
      }

      root.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.classList.remove('meriphora-page-drawer-lock');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      }

      window.setTimeout(() => {
        if (!root.classList.contains('is-open')) {
          overlay.hidden = true;
        }
      }, 240);
    };

    const getOpenDrawer = () => document.querySelector('[data-meriphora-page-drawer].is-open');

    const activateGuideTab = (button) => {
      const guide = button.closest('[data-meriphora-size-guide]');
      const target = button.dataset.sizeGuideTab;

      if (!guide || !target) {
        return;
      }

      guide.querySelectorAll('[data-size-guide-tab]').forEach((tab) => {
        const isActive = tab === button;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      guide.querySelectorAll('[data-size-guide-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.sizeGuidePanel !== target;
      });
    };

    const toggleGuideUnit = (button) => {
      const guide = button.closest('[data-meriphora-size-guide]');

      if (!guide) {
        return;
      }

      const unit = guide.dataset.activeUnit === 'in' ? 'cm' : 'in';
      guide.dataset.activeUnit = unit;
      syncGuideVisibility(guide);
    };

    const activateGuideCountry = (select) => {
      const guide = select.closest('[data-meriphora-size-guide]');

      if (!guide) {
        return;
      }

      guide.dataset.activeCountry = select.value || 'de';
      syncGuideVisibility(guide);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-meriphora-drawer-trigger]');
      if (trigger) {
        const root = getRoot(trigger);
        if (root) {
          openDrawer(root);
        }
        return;
      }

      const close = event.target.closest('[data-meriphora-drawer-close]');
      if (close) {
        const root = getRoot(close) || getRootFromOverlayChild(close);
        if (root) {
          closeDrawer(root);
        }
        return;
      }

      const tab = event.target.closest('[data-size-guide-tab]');
      if (tab) {
        activateGuideTab(tab);
        return;
      }

      const unit = event.target.closest('[data-size-guide-unit-toggle]');
      if (unit) {
        toggleGuideUnit(unit);
      }
    });

    document.addEventListener('change', (event) => {
      const country = event.target.closest('[data-size-guide-country]');

      if (country) {
        activateGuideCountry(country);
      }
    });

    document.addEventListener('keydown', (event) => {
      const openRoot = getOpenDrawer();

      if (!openRoot) {
        return;
      }

      if (event.key === 'Escape') {
        closeDrawer(openRoot);
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const openOverlay = getOverlay(openRoot);
      const focusScope = openOverlay || openRoot;
      const focusable = Array.from(focusScope.querySelectorAll(focusableSelector)).filter((item) => {
        return item.offsetParent !== null;
      });

      if (!focusable.length) {
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["meriphora-savings-badge"] && !Shopify.designMode) return;
  try {
    class MeriphoraSavingsBadge extends HTMLElement {
    connectedCallback() {
      const closestSection = this.closest('.shopify-section, dialog');

      if (!closestSection) return;

      this.closestSection = closestSection;
      this.closestSection.addEventListener('variant:update', this.updateBadge);
    }

    disconnectedCallback() {
      if (!this.closestSection) return;

      this.closestSection.removeEventListener('variant:update', this.updateBadge);
    }

    updateBadge = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      const newBadge = event.detail.data.html.querySelector(
        `meriphora-savings-badge[data-block-id="${this.dataset.blockId}"]`
      );

      if (!newBadge) return;

      this.replaceWith(newBadge);
    };
  }

  if (!customElements.get('meriphora-savings-badge')) {
    customElements.define('meriphora-savings-badge', MeriphoraSavingsBadge);
  }
  } catch(e) { console.error(e); }
})();

})();
